"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OG_IMAGE_API_URL = exports.DEFAULT_GALLERY_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = exports.ASSETS_URL = void 0;
exports.ASSETS_URL = 'https://cdn.uc.assets.prezly.com';
exports.DEFAULT_PAGE_SIZE = 12;
exports.DEFAULT_GALLERY_PAGE_SIZE = 6;
exports.OG_IMAGE_API_URL = 'https://og.prezly.com/api/og';
//# sourceMappingURL=constants.js.map